// extracted by mini-css-extract-plugin
export default {"overlay":"_z-z","bodyOpen":"aA-z","content":"bA-z","header":"cA-z","close":"dA-z","closeNoHeading":"eA-z"};